import './controls.scss';
import './onoffswitch.scss';
import Vue from 'vue';
import './formattingFilters.js';
import map from '../map';
import tpl from './controls.vue.html';
import types, {getTypesObject, getValuesFromName as getLayerValue} from '../types';

// vue model for layer types
export let controlsModel;

// initialize controls once the style loads
map.on('style.load', function(){
    // set default filters for each type
    types.forEach(function(type){
        type.baseFilter = map.getFilter(type.name);
    });
    // add wrapper element to DOM
    document.getElementById('app').insertAdjacentHTML('beforeend', tpl);

    // dynamically pre-select all types
    let typesArray = types.map(function(t){
        return t.name;
    });

    // dynamically populate all types
    let typesObject = getTypesObject();

    controlsModel = new Vue({
        el: '#app',
        data: {
            types: typesArray,
            visibleExtent: 0,
            areas: typesObject,
            years: [1985, 2011],
            layerTypes: types,
            yearsData: [],
        },
        methods: {
            inArray: function(val, array) {
                return (array.indexOf(val) === -1) ? false : true;
            },
            updateFilters: updateFilters,
            /**
             * select all (or none) of the type options
             */
            toggleAllTypes: function() {
                // clear types array
                let toggled = [];
                // if less than all, select all
                if (this.types.length < types.length) {
                    types.forEach((type) => {
                        toggled.push(type.name);
                    });
                }
                this.types = toggled;

                updateFilters();
            },
        }
    });
});

/**
 * update each layer's filters and re-apply on the map
 */
export function updateFilters() {
    // loop through each layer type
    for (let i = 0, numTypes = types.length; i < numTypes; i++) {
        let layer = types[i],
            layerFilters = ['all'].concat([layer.baseFilter]); // get base filter // @TODO: "all"? "any"? empty array?
        // type filter
        let typeValues = controlsModel.types.reduce(function(prev, curr) {
            // build a flat array of type values
            return prev.concat(getLayerValue(curr));
        }, []);
        layerFilters.push(['in', 'a'].concat(typeValues));
        // year filter
        if (controlsModel.years.length) {
            layerFilters.push(['>=', 'y'].concat(controlsModel.years[0]));
            layerFilters.push(['<=', 'y'].concat(controlsModel.years[1]));
        }
        // apply filters
        map.setFilter(layer.name, layerFilters);
    }

    // trigger view updates (recalculate areas based on visible dots)
    map.fire('filters.updated');
}



// WEBPACK FOOTER //
// ./src/js/controls/controls.js